export const ROOM_SCOPE = { value: 'room', label: 'Room' };
export const scopesOptions = [ROOM_SCOPE];
